import React from 'react'
import EsgEmailAlert from '../EsgEmailAlert'

export default function EsgWeeklyEmail({ data }) {
  return <EsgEmailAlert data={data} config={{ timeFrameDays: 7 }}/>
}
